var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import css from '@styled-system/css';
import React from 'react';
import styled from 'styled-components';
import { color, compose, flexbox, layout, space } from 'styled-system';
import theme from '../theme';
const TabContent = styled.div `
  ${css({
    color: 'gray.0',
    fontFamily: 'body'
})}
`;
const StyledTabs = styled.div `
  ${css({
    display: 'flex',
    flexDirection: 'row',
    padding: '0'
})}
  ${compose(color, flexbox, layout, space)}
`;
function Tabs(_a) {
    var { children, tabColor } = _a, rest = __rest(_a, ["children", "tabColor"]);
    const [activeIndex, setActiveIndex] = React.useState(0);
    const tabContent = children[activeIndex || 0].props.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTabs, Object.assign({}, rest), children.map((child, index) => React.cloneElement(child, {
            active: index === activeIndex,
            index,
            key: index,
            onClick: setActiveIndex,
            tabColor
        }))),
        React.createElement(TabContent, null, tabContent)));
}
Tabs.defaultProps = { theme };
export default Tabs;
//# sourceMappingURL=Tabs.js.map